export const MPSC_API_CAPTCHA_URL = [
    { key: "localhost", value: "localhost", baseUrl: "http://localhost:8080/web/api/v1/otps" },
    { key: "https://smbmpscweb.com", value: "https://smbmpscweb.com", baseUrl: "https://smbmpscweb.com/web/api/v1/otps" },
    { key: "https://mpsc.gov.in", value: "https://mpsc.gov.in", baseUrl: "https://mpsc.gov.in/web/api/v1/otps" },
]